export default "__VITE_ASSET__DAZeULPQ__"